import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  GetCountry,
  UpdateCountry,
} from "../../../store/country-store/country-actions";
import CountryForms from "../../../components/Forms/CountryForms";
import { getTokenInfo } from "../../../utils/Guard";

const CountryEdit = () => {
  const param = useParams();
  const dispatch = useDispatch();
  const country = useSelector((state) => state.country.country);
  const userInfo = getTokenInfo();

  useEffect(() => {
    if (country.id===undefined || country.id === 0) {
      dispatch(GetCountry(param.countryId, userInfo.Email));
    }
  }, [param.countryId, userInfo.Email, dispatch, country]);

  return (
    <>
    <div style={{ backgroundColor: "#133047", padding: "1%", height: "37.1rem" }}>
      <CountryForms actionCountry={UpdateCountry} country={country} />
      </div>
    </>
  );
};
export default CountryEdit;
